import { createAction } from 'redux-starter-kit';
import * as api from 'api/order';
import { addStatusMessage } from './status';

const PURCHASE_SUCCESS_MESSAGE = `purchased successfully. Thank you! If it's not available in the list below, please give it a few moments then refresh the page.`;

export const priceRegular = 27;
export const priceRegularInit = 67;
export const pricePremium = 37;
export const pricePremiumInit = 77;
export const priceAudioMegaBundle = 47;
export const priceAudioMegaBundleInit = 147;
export const priceUltimate = 497;

export const changePaymentMethod = createAction('order/CHANGE_PAYMENT_METHOD');
export const toggleSavedPaymentInfo = createAction('order/TOGGLE_SAVED_PAYMENT_INFO');
export const reset = createAction('order/CLEAR_REDICRECTION');

export const tokenizeStripe = createAction('order/TOKENIZE_STRIPE');
export const tokenizeStripeSuccess = createAction('order/TOKENIZE_STRIPE_SUCCESS');
export const tokenizeStripeFailure = createAction('order/TOKENIZE_STRIPE_FAILURE');

export const tokenizePaypal = createAction('order/TOKENIZE_PAYPAL');
export const tokenizePaypalSuccess = createAction('order/TOKENIZE_PAYPAL_SUCCESS');
export const tokenizePaypalFailure = createAction('order/TOKENIZE_PAYPAL_FAILURE');

export const orderBundle = createAction('order/ORDER_BUNDLE');
export const orderBundleSuccess = createAction('order/ORDER_BUNDLE_SUCCESS');
export const orderBundleFailure = createAction('order/ORDER_BUNDLE_FAILURE');
export const orderComplete = createAction('order/ORDER_COMPLETE');

export const orderTemplate = createAction('order/ORDER_TEMPLATE');
export const orderTemplateSuccess = createAction('order/ORDER_TEMPLATE_SUCCESS');
export const orderTemplateFailure = createAction('order/ORDER_TEMPLATE_FAILURE');

export const stripeRequireAction = createAction('order/STRIPE_REQUIRE_ACTION');
export const stripeConfirmPayment = createAction('order/STRIPE_CONFIRM_PAYMENT');
export const stripeConfirmPaymentSuccess = createAction('order/STRIPE_CONFIRM_PAYMENT_SUCCESS');
export const stripeConfirmPaymentFailure = createAction('order/STRIPE_CONFIRM_PAYMENT_FAILURE');

export const checkCaptcha = createAction('order/VERIFY_CAPTCHA');
export const checkCaptchaComplete = createAction('order/VERIFY_CAPTCHA_COMPLETE');

export const asyncOrderBundle = (bundleId, paymentInfo = {}) => dispatch => {
  dispatch(orderBundle());
  api
    .purchaseBundle(bundleId, paymentInfo)
    .then(data => {
      if (data.status && data.status === 'requires_action') {
        dispatch(stripeRequireAction(data));
      } else {
        dispatch(orderBundleSuccess());
        dispatch(addStatusMessage(`Bundle ${PURCHASE_SUCCESS_MESSAGE}`));
      }
    })
    .catch(err => {
      dispatch(orderBundleFailure({ error: err.message }));
    });
};

export const asyncOrderTemplate = (templateId, paymentInfo = {}) => dispatch => {
  dispatch(orderTemplate());
  api
    .purchaseTemplate(templateId, paymentInfo)
    .then(data => {
      if (data.status && data.status === 'requires_action') {
        dispatch(stripeRequireAction(data));
      } else {
        dispatch(orderTemplateSuccess());
        dispatch(addStatusMessage(`Template ${PURCHASE_SUCCESS_MESSAGE}`));
      }
    })
    .catch(err => {
      dispatch(orderTemplateFailure({ error: err.message }));
    });
};

export const asyncOrderUltimate = (paymentInfo = {}) => dispatch => {
  dispatch(orderBundle({ productId: paymentInfo.product_id }));
  api
    .purchaseUltimate(paymentInfo)
    .then(data => {
      if (data.status && data.status === 'requires_action') {
        dispatch(stripeRequireAction(data));
      } else {
        dispatch(orderBundleSuccess());
        dispatch(addStatusMessage(`Bundles ${PURCHASE_SUCCESS_MESSAGE}`));
      }
    })
    .catch(err => {
      dispatch(orderBundleFailure({ error: err.message }));
    });
};

export const asyncConfirmPaymentIntent = (paymentIntentId, invoiceId) => dispatch => {
  dispatch(stripeConfirmPayment());
  api
    .confirmPaymentIntent(paymentIntentId, invoiceId)
    .then(data => {
      if (data.error || data.errors) {
        dispatch(stripeConfirmPaymentFailure({ error: data.error || data.errors }));
      } else {
        dispatch(orderBundleSuccess());
        dispatch(addStatusMessage(`Bundle ${PURCHASE_SUCCESS_MESSAGE}`));
      }
    })
    .catch(err => {
      dispatch(stripeConfirmPaymentFailure({ error: err.message }));
    });
};

export const asyncCheckCaptcha = token => dispatch => {
  if (!token) {
    dispatch(checkCaptchaComplete({ success: false }));
    return;
  }

  const formData = new FormData();
  formData.append('token', token);
  dispatch(checkCaptcha());
  const serverUrl = 'https://www.doodly.com/api/recaptcha.php';
  // const serverUrl = '/api/recaptcha.php';
  fetch(serverUrl, {
    method: 'POST',
    mode: 'cors',
    body: formData
  })
    .then(res => res.json())
    .then(data => {
      dispatch(checkCaptchaComplete(data));
    });
};
